var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16c.6 0 1.087-.487 1.087-1.087V1.087a1.087 1.087 0 1 0-2.174 0v13.826c0 .6.486 1.087 1.087 1.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.087 9.087h13.826a1.087 1.087 0 1 0 0-2.174H1.087a1.087 1.087 0 1 0 0 2.174"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  })))));
};
export default SvgPlus;